import { formatSIRET } from 'helpers/siret';

/**
 * Our search input accepts both SIREN values and legal names.
 *
 * Therefore we've got some special tools to handle hybrid formatting of the content.
 */

/**
 * A 14+ length string composed only of numbers and spaces.
 * Looks suspiciously like a user entering a SIREN.
 */
const SIREN_LIKE = /^[\s\d]{9,}$/;

export const isSirenLike = (input: string) => SIREN_LIKE.test(input);

/**
 * If the input looks like a SIREN, strip its whitespaces.
 */
const stripSIRENWhitespaces = (input: string) =>
  isSirenLike(input) ? input.replace(/\s/g, '') : input;

/**
 * If the input is an exact SIRET, format it like one.
 */
const formatHybridSIREN = (input: string) =>
  isSirenLike(input) ? formatSIRET(input) : input;

export const hybridSiretInput = {
  mask: formatHybridSIREN,
  unmask: stripSIRENWhitespaces,
};
